<template>
  <button class="btn mb-0" :class="btnClasses" :disabled="disabled || loading">
    <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
    <slot />
  </button>
</template>

<script>
export default {
  name: "SoftButton",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "sm",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClasses() {
      const classes = [];

      if (this.variant === "gradient") {
        classes.push(`bg-gradient-${this.color}`);
      } else if (this.variant === "outline") {
        classes.push(`btn-outline-${this.color}`);
      } else {
        classes.push(`btn-${this.color}`);
      }

      if (this.size) classes.push(`btn-${this.size}`);
      if (this.fullWidth) classes.push("w-100");
      if (this.active) classes.push("active");

      return classes;
    },
  },
};
</script>
